// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var writeImpl = /* #__PURE__ */ Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var ListingInferenceSourceRef = function (x) {
    return x;
};
var ListingInferenceReviewer = function (x) {
    return x;
};
var ListingInferenceListingId = function (x) {
    return x;
};
var ListingInferenceDisposition = function (x) {
    return x;
};
var ListingInferenceDecisionReason = function (x) {
    return x;
};
var ListingInferenceClaimKind = function (x) {
    return x;
};
var ListingInferenceClaimId = function (x) {
    return x;
};
var ListingInferenceAgentTraceId = function (x) {
    return x;
};
var ListingInferenceAgentRequestId = function (x) {
    return x;
};
var writeListingInferenceSourceRef = function (v) {
    return v;
};
var writeListingInferenceSourceRefJson = {
    writeImpl: function ($45) {
        return writeImpl(writeListingInferenceSourceRef($45));
    }
};
var writeListingInferenceReviewer = function (v) {
    return v;
};
var writeListingInferenceReviewerJson = {
    writeImpl: function ($46) {
        return writeImpl(writeListingInferenceReviewer($46));
    }
};
var writeListingInferenceListingId = function (v) {
    return v;
};
var writeListingInferenceListingIdJson = {
    writeImpl: function ($47) {
        return writeImpl(writeListingInferenceListingId($47));
    }
};
var writeListingInferenceDisposition = function (v) {
    return v;
};
var writeListingInferenceDispositionJson = {
    writeImpl: function ($48) {
        return writeImpl(writeListingInferenceDisposition($48));
    }
};
var writeListingInferenceDecisionReason = function (v) {
    return v;
};
var writeListingInferenceDecisionReasonJson = {
    writeImpl: function ($49) {
        return writeImpl(writeListingInferenceDecisionReason($49));
    }
};
var writeListingInferenceClaimKind = function (v) {
    return v;
};
var writeListingInferenceClaimKindJson = {
    writeImpl: function ($50) {
        return writeImpl(writeListingInferenceClaimKind($50));
    }
};
var writeListingInferenceClaimId = function (v) {
    return v;
};
var writeListingInferenceClaimIdJson = {
    writeImpl: function ($51) {
        return writeImpl(writeListingInferenceClaimId($51));
    }
};
var writeListingInferenceAgentTraceId = function (v) {
    return v;
};
var writeListingInferenceAgentTraceIdJson = {
    writeImpl: function ($52) {
        return writeImpl(writeListingInferenceAgentTraceId($52));
    }
};
var writeListingInferenceAgentRequestId = function (v) {
    return v;
};
var writeListingInferenceAgentRequestIdJson = {
    writeImpl: function ($53) {
        return writeImpl(writeListingInferenceAgentRequestId($53));
    }
};
var validateNonEmpty = function (message) {
    return function (wrap) {
        return function (value) {
            var normalized = Data_String_Common.trim(value);
            var $39 = normalized === "";
            if ($39) {
                return new Data_Either.Left(message);
            };
            return new Data_Either.Right(wrap(normalized));
        };
    };
};
var validateListingInferenceSourceRef = /* #__PURE__ */ validateNonEmpty("source reference must be non-empty")(ListingInferenceSourceRef);
var validateListingInferenceReviewer = /* #__PURE__ */ validateNonEmpty("reviewer must be non-empty")(ListingInferenceReviewer);
var validateListingInferenceListingId = /* #__PURE__ */ validateNonEmpty("listing id must be non-empty")(ListingInferenceListingId);
var validateListingInferenceDecisionReason = /* #__PURE__ */ validateNonEmpty("decision reason must be non-empty")(ListingInferenceDecisionReason);
var validateListingInferenceClaimId = /* #__PURE__ */ validateNonEmpty("claim id must be non-empty")(ListingInferenceClaimId);
var validateListingInferenceAgentTraceId = /* #__PURE__ */ validateNonEmpty("agent trace id must be non-empty")(ListingInferenceAgentTraceId);
var validateListingInferenceAgentRequestId = /* #__PURE__ */ validateNonEmpty("agent request id must be non-empty")(ListingInferenceAgentRequestId);
var tsBridgeListingInferenceSourceRef = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceSourceRef")("__brandListingInferenceSourceRef"));
    }
};
var tsBridgeListingInferenceReviewer = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceReviewer")("__brandListingInferenceReviewer"));
    }
};
var tsBridgeListingInferenceListingId = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceListingId")("__brandListingInferenceListingId"));
    }
};
var tsBridgeListingInferenceDisposition = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceDisposition")("__brandListingInferenceDisposition"));
    }
};
var tsBridgeListingInferenceDecisionReason = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceDecisionReason")("__brandListingInferenceDecisionReason"));
    }
};
var tsBridgeListingInferenceClaimKind = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceClaimKind")("__brandListingInferenceClaimKind"));
    }
};
var tsBridgeListingInferenceClaimId = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceClaimId")("__brandListingInferenceClaimId"));
    }
};
var tsBridgeListingInferenceAgentTraceId = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceAgentTraceId")("__brandListingInferenceAgentTraceId"));
    }
};
var tsBridgeListingInferenceAgentRequestId = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ListingInferenceAgentRequestId")("__brandListingInferenceAgentRequestId"));
    }
};
var showListingInferenceSourceRef = Data_Show.showString;
var showListingInferenceReviewer = Data_Show.showString;
var showListingInferenceListingId = Data_Show.showString;
var showListingInferenceDisposition = Data_Show.showString;
var showListingInferenceDecisionReason = Data_Show.showString;
var showListingInferenceClaimKind = Data_Show.showString;
var showListingInferenceClaimId = Data_Show.showString;
var showListingInferenceAgentTraceId = Data_Show.showString;
var showListingInferenceAgentRequestId = Data_Show.showString;
var readValidated = function (validate) {
    return function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = validate(raw);
            if (v instanceof Data_Either.Right) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Either.Left) {
                return fail(new Foreign.ForeignError(v.value0));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Brands.ListingInferenceReviewPortal (line 199, column 3 - line 201, column 56): " + [ v.constructor.name ]);
        });
    };
};
var readListingInferenceSourceRef = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceSourceRef)
};
var readListingInferenceReviewer = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceReviewer)
};
var readListingInferenceListingId = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceListingId)
};
var readListingInferenceDecisionReason = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceDecisionReason)
};
var readListingInferenceClaimId = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceClaimId)
};
var readListingInferenceAgentTraceId = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceAgentTraceId)
};
var readListingInferenceAgentRequestId = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceAgentRequestId)
};
var ordListingInferenceSourceRef = Data_Ord.ordString;
var ordListingInferenceReviewer = Data_Ord.ordString;
var ordListingInferenceListingId = Data_Ord.ordString;
var ordListingInferenceDisposition = Data_Ord.ordString;
var ordListingInferenceDecisionReason = Data_Ord.ordString;
var ordListingInferenceClaimKind = Data_Ord.ordString;
var ordListingInferenceClaimId = Data_Ord.ordString;
var ordListingInferenceAgentTraceId = Data_Ord.ordString;
var ordListingInferenceAgentRequestId = Data_Ord.ordString;
var newtypeListingInferenceSourceRef = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceReviewer = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceListingId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceDisposition = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceDecisionReason = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceClaimKind = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceClaimId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceAgentTraceId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeListingInferenceAgentRequestId = {
    Coercible0: function () {
        return undefined;
    }
};
var makeListingInferenceSourceRef = validateListingInferenceSourceRef;
var makeListingInferenceReviewer = validateListingInferenceReviewer;
var makeListingInferenceListingId = validateListingInferenceListingId;
var makeListingInferenceDecisionReason = validateListingInferenceDecisionReason;
var makeListingInferenceClaimId = validateListingInferenceClaimId;
var makeListingInferenceAgentTraceId = validateListingInferenceAgentTraceId;
var makeListingInferenceAgentRequestId = validateListingInferenceAgentRequestId;
var isListingInferenceDisposition = function (value) {
    return value === "proposed" || (value === "confirmed" || (value === "rejected" || value === "conflicted"));
};
var validateListingInferenceDisposition = function (value) {
    var normalized = Data_String_Common.trim(value);
    var $43 = isListingInferenceDisposition(normalized);
    if ($43) {
        return new Data_Either.Right(normalized);
    };
    return new Data_Either.Left("disposition must be proposed, confirmed, rejected, or conflicted");
};
var makeListingInferenceDisposition = validateListingInferenceDisposition;
var readListingInferenceDisposition = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceDisposition)
};
var isListingInferenceClaimKind = function (value) {
    return value === "partyIdentity" || (value === "partyRole" || value === "partyRelationship");
};
var validateListingInferenceClaimKind = function (value) {
    var normalized = Data_String_Common.trim(value);
    var $44 = isListingInferenceClaimKind(normalized);
    if ($44) {
        return new Data_Either.Right(normalized);
    };
    return new Data_Either.Left("claim kind must be partyIdentity, partyRole, or partyRelationship");
};
var makeListingInferenceClaimKind = validateListingInferenceClaimKind;
var readListingInferenceClaimKind = {
    readImpl: /* #__PURE__ */ readValidated(validateListingInferenceClaimKind)
};
var eqListingInferenceSourceRef = Data_Eq.eqString;
var eqListingInferenceReviewer = Data_Eq.eqString;
var eqListingInferenceListingId = Data_Eq.eqString;
var eqListingInferenceDisposition = Data_Eq.eqString;
var eqListingInferenceDecisionReason = Data_Eq.eqString;
var eqListingInferenceClaimKind = Data_Eq.eqString;
var eqListingInferenceClaimId = Data_Eq.eqString;
var eqListingInferenceAgentTraceId = Data_Eq.eqString;
var eqListingInferenceAgentRequestId = Data_Eq.eqString;
export {
    ListingInferenceListingId,
    ListingInferenceClaimId,
    ListingInferenceClaimKind,
    ListingInferenceDisposition,
    ListingInferenceReviewer,
    ListingInferenceDecisionReason,
    ListingInferenceSourceRef,
    ListingInferenceAgentRequestId,
    ListingInferenceAgentTraceId,
    makeListingInferenceListingId,
    validateListingInferenceListingId,
    makeListingInferenceClaimId,
    validateListingInferenceClaimId,
    makeListingInferenceClaimKind,
    validateListingInferenceClaimKind,
    makeListingInferenceDisposition,
    validateListingInferenceDisposition,
    makeListingInferenceReviewer,
    validateListingInferenceReviewer,
    makeListingInferenceDecisionReason,
    validateListingInferenceDecisionReason,
    makeListingInferenceSourceRef,
    validateListingInferenceSourceRef,
    makeListingInferenceAgentRequestId,
    validateListingInferenceAgentRequestId,
    makeListingInferenceAgentTraceId,
    validateListingInferenceAgentTraceId,
    newtypeListingInferenceListingId,
    newtypeListingInferenceClaimId,
    newtypeListingInferenceClaimKind,
    newtypeListingInferenceDisposition,
    newtypeListingInferenceReviewer,
    newtypeListingInferenceDecisionReason,
    newtypeListingInferenceSourceRef,
    newtypeListingInferenceAgentRequestId,
    newtypeListingInferenceAgentTraceId,
    eqListingInferenceListingId,
    ordListingInferenceListingId,
    showListingInferenceListingId,
    eqListingInferenceClaimId,
    ordListingInferenceClaimId,
    showListingInferenceClaimId,
    eqListingInferenceClaimKind,
    ordListingInferenceClaimKind,
    showListingInferenceClaimKind,
    eqListingInferenceDisposition,
    ordListingInferenceDisposition,
    showListingInferenceDisposition,
    eqListingInferenceReviewer,
    ordListingInferenceReviewer,
    showListingInferenceReviewer,
    eqListingInferenceDecisionReason,
    ordListingInferenceDecisionReason,
    showListingInferenceDecisionReason,
    eqListingInferenceSourceRef,
    ordListingInferenceSourceRef,
    showListingInferenceSourceRef,
    eqListingInferenceAgentRequestId,
    ordListingInferenceAgentRequestId,
    showListingInferenceAgentRequestId,
    eqListingInferenceAgentTraceId,
    ordListingInferenceAgentTraceId,
    showListingInferenceAgentTraceId,
    readListingInferenceListingId,
    writeListingInferenceListingIdJson,
    readListingInferenceClaimId,
    writeListingInferenceClaimIdJson,
    readListingInferenceClaimKind,
    writeListingInferenceClaimKindJson,
    readListingInferenceDisposition,
    writeListingInferenceDispositionJson,
    readListingInferenceReviewer,
    writeListingInferenceReviewerJson,
    readListingInferenceDecisionReason,
    writeListingInferenceDecisionReasonJson,
    readListingInferenceSourceRef,
    writeListingInferenceSourceRefJson,
    readListingInferenceAgentRequestId,
    writeListingInferenceAgentRequestIdJson,
    readListingInferenceAgentTraceId,
    writeListingInferenceAgentTraceIdJson,
    tsBridgeListingInferenceListingId,
    tsBridgeListingInferenceClaimId,
    tsBridgeListingInferenceClaimKind,
    tsBridgeListingInferenceDisposition,
    tsBridgeListingInferenceReviewer,
    tsBridgeListingInferenceDecisionReason,
    tsBridgeListingInferenceSourceRef,
    tsBridgeListingInferenceAgentRequestId,
    tsBridgeListingInferenceAgentTraceId
};
//# sourceMappingURL=index.js.map
